export * from './map';
export * from './webviewEnv';
export * from './nativeCommand';
export * from './platform';
export * from './rem';
export * from './device';
//路由路径信息
export * from './paths';

//登录时的系统码key
export const appCode = 'seewo-yunban-mobile';

//动画执行时长，专用于小程序端(因为小程序端无法正常触发animationend)
//数值少16毫秒是为了能早一点点触发，否则可能会出现闪烁的现象
export const animationDurations = {
  fadeOutUp: 184,
  fadeOut: 184,
  moveOutLeft: 284,
  moveOutDown: 284,
  easeOutQuintDown: 484,
  fadeAway: 1000
};

//设备状态
export const deviceStatus = {
  /**
   * 设备在线
   */
  online: 1,
  /**
   * 设备离线
   */
  offline: 2,
  /**
   * 设备被锁定
   */
  locked: 3,
  /**
   * 设备被禁用
   */
  forbid: 4,
}

export const deviceStatusName = {
  [deviceStatus.online]: '在线',
  [deviceStatus.offline]: '离线',
  [deviceStatus.locked]: '锁定',
  [deviceStatus.forbid]: '离线',
}

export const systemCode = 'seewo-campus-cube-mobile';

/**
 * 判断是否位于IOS环境之下
 */
export const isInIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);